import React from "react";
import { AiOutlineUser } from "react-icons/ai";

/**
 * Avatar / role indicator on the leading edge of every message.
 */
const MessageProfile = ({ role }) => {
  if (role === "user") {
    return (
      <div className="user-logo--wrapper">
        <AiOutlineUser
          style={{ fontSize: "20px", color: "var(--action-primary)" }}
        />
      </div>
    );
  }

  return (
    <div className="copilot-logo--wrapper">
      <img src="/logo.svg" alt="" />
    </div>
  );
};

export default MessageProfile;
